import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { CiLock } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import naptinlogo from "../../../img/naptinlogo.png";
import mail_icon from "../../../img/red_mail_icon.svg";
import authService from "../../../services/auth.service";
import routes from "../../routes";
const VerifyEmail = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const email = localStorage.getItem("userMail")?.toString();
  const [token, setToken] = useState("");
  const login = () => {
    localStorage.removeItem("userMail");
    navigate(routes.Login);
  };

  const verifyUser = () => {
    authService
      .verifyEmail(token)
      .then((res) => {
        toast({
          title: "Registration",
          description: "Verification successful",
          status: "success",
        });
        navigate(routes.Login);
        localStorage.removeItem("userMail");
      })
      .catch((e: any) => {
        const e_message =
          e?.response.data.message || "Something went wrong, try again later !";
        toast({
          title: "Registration",
          description: `${e_message}`,
          status: "error",
        });
      })
      .finally(() => {
        setToken("");
      });
  };

  return (
    <>
      <Box>
        <Flex
          height="65px"
          bg="#FFFFFF"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px={"10px"}
        >
          <Flex alignItems="center">
            <Box as="span">
              <Image src={naptinlogo} height="45px" />
            </Box>
          </Flex>
        </Flex>
      </Box>
      <Flex
        width="100%"
        justifyContent="center"
        alignItems={"center"}
        height="100vh"
        bg=" #F9F8F8"
      >
        <Box
          boxShadow="base"
          bg="white"
          borderRadius="20px"
          height="530px"
          width={["90%", "80%", "70%", "50%"]}
          color="#353535"
          textAlign="center"
          padding={["1.5rem", "2rem", "2rem", "3rem"]}
        >
          <Flex justifyContent="flex-start" mt="20px">
            <Image src={mail_icon} />
          </Flex>
          <Text
            fontSize="24px"
            fontWeight="500"
            pt="45px"
            pb="14px"
            textAlign={"left"}
          >
            Verification Code Sent to Your Email
          </Text>
          <FormControl mb={14}>
            <FormLabel color="#959595" fontSize={12}>
              Enter the verification code sent to {email}
            </FormLabel>
            <InputGroup>
              <InputLeftElement
                color="#959595"
                pointerEvents="none"
                children={<CiLock color="#959595" />}
              />
              <Input
                type="text"
                placeholder="XXXXX"
                name="token"
                value={token}
                onChange={(e) => {
                  setToken(e.target.value);
                }}
                fontSize={13}
              />
            </InputGroup>
          </FormControl>
          <Button
            py="13px"
            px="30px"
            float={"right"}
            onClick={() => {
              verifyUser();
            }}
            fontSize={14}
            borderRadius={0}
            colorScheme="red"
            size="xl"
            isDisabled={token == ""}
          >
            CONFIRM
          </Button>
        </Box>
      </Flex>
    </>
  );
};

export default VerifyEmail;
